// Helpers para filtrar empleados según la frecuencia de pago vs el tipo de período visible
export const TIPO_TO_FRECUENCIA = { semanal: "Semanal", quincenal: "Quincenal" };

export function matchesFrecuencia(empleado, tipo) {
  if (!empleado) return false;
  return (empleado.frecuencia_pago || "Mensual") === TIPO_TO_FRECUENCIA[tipo];
}

// Empleados visibles en un tab Semanal/Quincenal (solo activos + frecuencia coincidente)
export function empleadosPorTipo(empleados, tipo) {
  return empleados.filter(e => e.estado === "Activo" && matchesFrecuencia(e, tipo));
}

// ¿El empleado estaba contratado al día indicado (fecha ISO YYYY-MM-DD)?
export function empleadoActivoEn(empleado, fechaISO) {
  if (!empleado || !fechaISO) return false;
  if (!empleado.fecha_ingreso) return true; // sin fecha de ingreso → asume siempre activo
  return empleado.fecha_ingreso <= fechaISO;
}

// Filtra empleados que existían en (o antes de) la fecha
export function empleadosVisiblesEn(empleados, fechaISO) {
  return empleados.filter(e => empleadoActivoEn(e, fechaISO));
}
